import { Component, OnInit } from '@angular/core';
import { LicenseService } from '../../../../services/license/license.service';
import { BaseComponent } from '../../../base.component';
import { ClientService } from '../../../../services/clients/client.service';

@Component({
  selector: 'app-addon-catalog-listing',
  templateUrl: './addon-catalog-listing.component.html',
  styleUrls: ['./addon-catalog-listing.component.css']
})
export class AddonCatalogListingComponent extends BaseComponent implements OnInit {

  cp = 1;
  text;
  getCompanyobj: any = [];
  catalogData: any = [];
  selectedCompany: any = 0;
  independentNote = '';
  order: string = 'addon_sort';
  reverse: boolean = false;

  constructor(
    private clientService: ClientService,
    private LS: LicenseService
  ) { super(); }

  ngOnInit() {
    if (localStorage.getItem('edit_addon_catalog_id')) {
      localStorage.removeItem('edit_addon_catalog_id');
      localStorage.removeItem('edit_addon_catalog_company_id');
    }
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      this.hydrateWorkingCompany(this, (id) => { this.loadCatalog(id); });
    }, error => {
    });
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }

  isIndependentCompany() {
    if (!this.getCompanyobj || !this.selectedCompany) {
      return false;
    }
    const row = this.getCompanyobj.find((item: any) => String(item.customer_id) === String(this.selectedCompany));
    return !!(row && row.is_bu === false);
  }

  onCompanyChange(value?: any) {
    this.text = '';
    this.cp = 1;
    this.loadCatalog(value);
  }
  resetFilters() {
    this.text = '';
    this.cp = 1;
    const working = this.bindWorkingCompany(this.getCompanyobj);
    this.selectedCompany = working ? working : 0;
    this.loadCatalog(this.selectedCompany);
  }
  loadCatalog(id) {
    this.cp = 1;
    this.independentNote = '';
    if (id > 0) {
      this.selectedCompany = id;
      if (!this.isIndependentCompany()) {
        this.catalogData = [];
        this.independentNote = 'Add-on catalog is available for independent companies only.';
        return;
      }
      this.ngxSpinnerService.show();
      this.LS.getAddonCatalog(id).subscribe(data => {
        if (data.status) {
          this.catalogData = data.data || [];
        } else {
          this.catalogData = [];
          this.independentNote = data.message || '';
        }
        this.ngxSpinnerService.hide();
      }, error => {
        this.catalogData = [];
        this.ngxSpinnerService.hide();
      });
    } else {
      this.catalogData = [];
    }
  }

  editAddon(id) {
    localStorage.setItem('edit_addon_catalog_id', id);
    localStorage.setItem('edit_addon_catalog_company_id', this.selectedCompany.toString());
    this.router.navigate(['/corporate/addon-catalog-edit']);
  }

  updateSellableStatus(id, status) {
    const nextStatus = status ? false : true;
    this.confirmationDialogService.confirm(
      'PLEASE CONFIRM',
      'Are you sure you want to change sellable status to ' + (nextStatus ? 'Yes?' : 'No?'),
      'Ok',
      'Cancel'
    ).then((confirmed) => {
      if (confirmed) {
        const obj = {
          company: this.selectedCompany,
          bundle_id: id,
          is_addon_sellable: nextStatus
        };
        this.LS.updateAddonCatalogStatus(obj).subscribe(data => {
          if (data.status) {
            this.toastrService.success('Add-on catalog status updated successfully');
            this.loadCatalog(this.selectedCompany);
          } else {
            this.toastrService.error(data.message);
          }
        }, error => {
        });
      }
    }).catch(() => { });
  }
}
